import { useMemo } from 'react';
import { useAuth } from '../contexts/AuthContext';
import type { AccessiblePage } from '../types/auth';

/**
 * Hook to get the list of pages the current user can access
 */
export function useAccessiblePages(): { pages: AccessiblePage[]; isLoading: boolean } {
    const { user, isLoading } = useAuth();

    return useMemo(() => ({
        pages: user?.accessiblePages ?? [],
        isLoading,
    }), [user, isLoading]);
}
